import {
    GET_LIST_CUSTOMER_CARE_LOG,
    GET_SPECIFIC_CUSTOMER_CARE_LOG,
    UPDATE_SPECIFIC_CUSTOMER_CARE_LOG,
    REMOVE_CUSTOMER_CARE_LOG
} from '@/redux/actions/types';

/**
 * initial state cho module Customer Care Log
 */
const INIT_STATE = {
    customerCareLogList: [],        // danh sách log CSKH theo customer
    currentCustomerCareLog: null,   // record chi tiết (edit)
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 50
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        /** 
         * Lấy danh sách log CSKH theo customer 
         */
        case GET_LIST_CUSTOMER_CARE_LOG: {
            return {
                ...state,
                customerCareLogList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page || 1),
                    total: parseInt(action.payload.total || 0),
                    perPage: parseInt(action.payload.per_page || 50),
                }
            };
        }

        /** 
         * Lấy chi tiết 1 log 
         */
        case GET_SPECIFIC_CUSTOMER_CARE_LOG: {
            return {
                ...state,
                currentCustomerCareLog: action.payload
            };
        }

        /** 
         * Cập nhật log CSKH 
         */
        case UPDATE_SPECIFIC_CUSTOMER_CARE_LOG: {
            const updatedList = state.customerCareLogList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                customerCareLogList: updatedList,
                currentCustomerCareLog: action.payload
            };
        }

        /** 
         * Xoá một hoặc nhiều log CSKH 
         */
        case REMOVE_CUSTOMER_CARE_LOG: {
            const filteredList = state.customerCareLogList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                customerCareLogList: filteredList,
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total - action.payload.length
                }
            };
        }

        default:
            return { ...state };
    }
};
